import { Action } from '@ngrx/store';

export const SESSION_EXTENDED = '[Security] Session Extended';

export class SessionExtendedAction implements Action {
  readonly type = SESSION_EXTENDED;
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/SessionExtendedAction.ts